const paletteDark = {
  'red': {
    '100': '#481519',
    '200': '#880000',
    '300': '#bb0000',
    '400': '#d04343',
    '500': '#ed5e5e',
    '600': '#ff9286',
    '700': '#ffbab2',
    '800': '#ffdfdb',
    '900': '#ffebeb'
  },
  'orange': {
    '100': '#421b07',
    '200': '#792d06',
    '300': '#b34b0f',
    '400': '#e9730c',
    '500': '#f58b2e',
    '600': '#f7ab5e',
    '700': '#ffc890',
    '800': '#ffe3c7',
    '900': '#fef7f1'
  },
  'yellow': {
    '100': '#351f00',
    '200': '#663c00',
    '300': '#a35f00',
    '400': '#d08014',
    '500': '#eaa315',
    '600': '#f4bd3b',
    '700': '#fad963',
    '800': '#fdeea1',
    '900': '#fff9db'
  },
  'lime': {
    '100': '#243503',
    '200': '#42590d',
    '300': '#617e10',
    '400': '#7ca10c',
    '500': '#99bb1b',
    '600': '#b4ce35',
    '700': '#d4e45f',
    '800': '#ecf49f',
    '900': '#f5fad1'
  },
  'green': {
    '100': '#163204',
    '200': '#264810',
    '300': '#3d6821',
    '400': '#528c2b',
    '500': '#6ab03b',
    '600': '#8fd163',
    '700': '#b0e98b',
    '800': '#d6f8c0',
    '900': '#ebffde'
  },
  'mint': {
    '100': '#08361a',
    '200': '#15562f',
    '300': '#107e3e',
    '400': '#2a9856',
    '500': '#3abf6f',
    '600': '#67dc96',
    '700': '#96efb9',
    '800': '#cffce1',
    '900': '#f1fdf6'
  },
  'teal': {
    '100': '#083233',
    '200': '#12464a',
    '300': '#176770',
    '400': '#0f828f',
    '500': '#2eacb8',
    '600': '#5fcfd3',
    '700': '#93e9ec',
    '800': '#c6f7f9',
    '900': '#ebfeff'
  },
  'azure': {
    '100': '#06294b',
    '200': '#053b70',
    '300': '#0854a0',
    '400': '#0a6ed1',
    '500': '#3c8cdd',
    '600': '#6ca8e3',
    '700': '#a0cefc',
    '800': '#d6eeff',
    '900': '#f5faff'
  },
  'blue': {
    '100': '#202360',
    '200': '#313481',
    '300': '#4646b9',
    '400': '#6367de',
    '500': '#7484e7',
    '600': '#97abfc',
    '700': '#b8ccff',
    '800': '#d6e4ff',
    '900': '#f1f6ff'
  },
  'purple': {
    '100': '#371565',
    '200': '#4c2682',
    '300': '#6b3da3',
    '400': '#925ace',
    '500': '#aa78f0',
    '600': '#c0a0ff',
    '700': '#d5c3ff',
    '800': '#e5dbff',
    '900': '#f4f0ff'
  },
  'magenta': {
    '100': '#430e3f',
    '200': '#6e1c60',
    '300': '#962c7c',
    '400': '#c0399f',
    '500': '#d265b7',
    '600': '#e892d9',
    '700': '#f6b9f1',
    '800': '#ffd6ff',
    '900': '#fef0ff'
  },
  'pink': {
    '100': '#491124',
    '200': '#7a1f45',
    '300': '#b01c5a',
    '400': '#db1f77',
    '500': '#e94e96',
    '600': '#f18cbf',
    '700': '#f7b6da',
    '800': '#fcddef',
    '900': '#ffeff8'
  },
  'graphite': {
    '050': '#232a31',
    '100': '#1d3044',
    '200': '#354a5f',
    '300': '#485d70',
    '400': '#647987',
    '500': '#869eac',
    '600': '#a6bcc9',
    '700': '#c4d3dd',
    '800': '#e2eaf1',
    '900': '#f1f6fb'
  },
  'gray': {
    '000': '#000000',
    '050': '#32363a',
    '100': '#32363a',
    '150': '#3e4247',
    '200': '#3e4247',
    '250': '#56595d',
    '300': '#56595d',
    '350': '#6a6d70',
    '400': '#6a6d70',
    '450': '#89919a',
    '500': '#89919a',
    '550': '#b7bcc2',
    '600': '#b7bcc2',
    '650': '#d3d6d9',
    '700': '#d3d6d9',
    '750': '#e5e5e5',
    '800': '#e5e5e5',
    '850': '#f7f7f7',
    '900': '#f7f7f7',
    '999': '#ffffff'
  }
};

const namedColorsDark = {
  'brand-a': paletteDark.mint['500'],
  'brand-b': paletteDark.blue['500'],
  'brand-c': paletteDark.lime['500'],
  'brand-d': paletteDark.gray['500'],
  'brand-shell': {
    'default': paletteDark.graphite['200'],
    'faint': paletteDark.graphite['300'],
    'text': paletteDark.gray['999']
  },
  'chart-01': {
    ...paletteDark.blue,
    'default': paletteDark.blue['500']
  },
  'chart-02': {
    ...paletteDark.orange,
    'default': paletteDark.orange['500']
  },
  'chart-03': {
    ...paletteDark.mint,
    'default': paletteDark.mint['500']
  },
  'chart-04': {
    ...paletteDark.magenta,
    'default': paletteDark.magenta['500']
  },
  'chart-05': {
    ...paletteDark.gray,
    'default': paletteDark.gray['500']
  },
  'chart-06': {
    ...paletteDark.purple,
    'default': paletteDark.purple['400']
  },
  'chart-07': {
    ...paletteDark.yellow,
    'default': paletteDark.yellow['400']
  },
  'chart-08': {
    ...paletteDark.pink,
    'default': paletteDark.pink['400']
  },
  'chart-09': {
    ...paletteDark.azure,
    'default': paletteDark.azure['400']
  },
  'chart-10': {
    ...paletteDark.teal,
    'default': paletteDark.teal['400']
  },
  'background': {
    'default': '#29313a',
    'faint': '#232a31',
    'disabled': paletteDark.gray['200'],
    'hover': paletteDark.gray['100'],
    'active': paletteDark.gray['200'],
    'active-hover': paletteDark.gray['300']
  },
  'text': {
    'default': paletteDark.gray['900'],
    'faint': paletteDark.gray['850']
  },
  'border': paletteDark.gray['200'],
  'shadow': paletteDark.gray['999'],
  'success': {
    ...paletteDark.mint,
    'default': paletteDark.mint['400']
  },
  'danger': {
    ...paletteDark.red,
    'default': paletteDark.red['400']
  },
  'error': {
    ...paletteDark.red,
    'default': paletteDark.red['400'],
    'faint': paletteDark.red['300']
  },
  'warning': {
    ...paletteDark.yellow,
    'default': paletteDark.yellow['400']
  },
  'info': {
    ...paletteDark.azure,
    'default': paletteDark.azure['500']
  },
  'primary': {
    ...paletteDark.azure,
    'default': paletteDark.azure['500']
  },
  'highlight': {
    ...paletteDark.azure,
    'default': paletteDark.azure['600']
  },
  'alert': {
    ...paletteDark.pink,
    'default': paletteDark.pink['400']
  }
};

module.exports = {
  paletteDark,
  namedColorsDark
};
